module.exports = __webpack_public_path__ + "createstatic/media/newproject.4e13cc7b.svg";